export const ContactMethods = {
  ALL: "All",
  SMS: "SMS",
  EMAIL: "Email",
  WHATSAPP: "Whatsapp",
  CALL: "Call",
};

export const ContactMethodsArray = [
  ContactMethods.ALL,
  ContactMethods.SMS,
  ContactMethods.EMAIL,
  ContactMethods.WHATSAPP,
  ContactMethods.CALL,
];

export const ContactMethodsCsv = ContactMethodsArray.filter(
  (method) => method !== ContactMethods.ALL
).join(",");
